import React, { useEffect, useState } from 'react';
import IsecNavbar from './IsecNavbar';
import './pages-css/AddVulnerability.css';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../Context/UserContext.js'
// import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faL, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IsecNavbar2 from './IsecNavbar2';
import { url } from '../../constants/url';
import ClientNavbar1 from '../../Client-components/Pages/ClientNavbar1.jsx';


const AddVulnerability = () => {
  const { projectid } = useParams();

  const [searchParams] = useSearchParams();
  const vulId = searchParams.get('vulId');

  const navigate = useNavigate()

  let previousLength = 0;

  const { logout, emailVer, isSidebarCollapsed } = useAuth()

  const [vulnerability, setVulnerability] = useState('');
  const [severity, setSeverity] = useState('');
  const [description, setDescription] = useState('');
  const [parameter, setParameter] = useState('');
  const [recommend, setrecommend] = useState('');
  const [OWASP, setOWASP] = useState('')
  const [files, setFiles] = useState([]);
  const [score, setScore] = useState('')
  const [cveId, setCveId] = useState('')
  const [string, setString] = useState('')
  const [exploitation, setExpolitation] = useState('')
  const [factor, setFactor] = useState('')
  const [risk, setRisk] = useState('')
  const [waitingPage, setWaitingPage] = useState(false)
  const [pocDescription, setPocDescription] = useState([
    {
      poc: '',
    },
  ]);


  const [vulnerabilityError, setVulnerabilityError] = useState('')
  const [severityError, setSeverityError] = useState('')
  const [descriptionError, setDescriptionError] = useState('');
  const [parameterError, setParameterError] = useState('')
  const [recommendationsError, setrecommendationsError] = useState('')
  const [fileError, setFileError] = useState('')
  const [OWASPError, setOWASPError] = useState('')
  const [scoreError, setScoreError] = useState('')
  const [stringError, setStringError] = useState('')
  const [exploitationError, setExploitationError] = useState('')
  const [factorError, setFactorError] = useState('')
  const [cveIdError, setCveIdError] = useState('')
  const [riskError, setRiskError] = useState('')
  const [projectName, setProjectName] = useState('')
  const [applicationType, setApplicationType] = useState('')
  const [isEditMode, setIsEditMode] = useState(false)
  const [loading, setLoading] = useState(false)

  const addVulnerabilitySuccess = () => {
    toast.success("Vulnerability added successfully...", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const addVulnerabilityError = () => {
    toast.error("Error uploading vulnerability", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFiles(e.target.files);
      setFileError('');
    } else {
      setFileError('Please upload a valid file.');
    }
  };

  // Refer project.js file for backend code
  const fetchProjectName = async () => {
    try {
      const response = await fetch(`${url}/fetchprojectname?projectId=${projectid}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include'
      })
      const result = await response.json();
      setProjectName(result.projectName)
      setApplicationType(result.applicationType)
      if (response.status === 403) {
        logout()
        return
      }
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }

    } catch (error) {
      console.log(error);
    }
  }

  const fetchPOCImages = async (vulId, currentPoc) => {
    try {
      const response = await fetch(`${url}/fetcheditpoc?vulnerabilityId=${vulId}`, {
        method: "GET",
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      });

      if (response.status === 440) {
        return navigate('/');
      }

      let fetchedFiles = [];
      if (response.ok) {
        const text = await response.text();
        if (text.trim()) {
          fetchedFiles = JSON.parse(text);
        }
      }
      const imageBlobs = await Promise.all(
        fetchedFiles.map(async file => {
          try {
            const imageResponse = await fetch(file.url, { method: 'GET', credentials: 'include' });
            const blob = await imageResponse.blob();

            // Convert blob → File so it can be sent in FormData
            const fileObj = new File([blob], file.fileName, { type: blob.type });

            return {
              fileName: file.fileName,
              filePath: `${file.pocFolder}/${file.fileName}`,
              fileObj,
              objectUrl: URL.createObjectURL(blob)
            };
          } catch (err) {
            console.error(`Failed to fetch image blob for ${file.fileName}`, err);
            return null;
          }
        })
      );
      const validImages = imageBlobs.filter(Boolean);
      // Merge into PoC description with both path & File
      const merged = currentPoc.map(pocItem => {
        const foundImage = validImages.find(img =>
          img.fileName && pocItem.filePath?.includes(img.fileName)
        );
        return {
          ...pocItem,
          filePath: pocItem.filePath || foundImage?.filePath || null,
          files: foundImage ? [foundImage.fileObj] : [], // ✅ store File here
          pocImageURL: foundImage ? foundImage.objectUrl : null
        };
      });
      setPocDescription(merged);

    } catch (error) {
      console.error("Error fetching PoC images:", error);
    }
  };

  const fetchVulnerabilityDetails = async (id) => {
    try {
      const res = await fetch(`${url}/fetchvulnerabilitybyid?vulId=${id}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!res.ok) throw new Error("Failed to fetch vulnerability details");
      const data = await res.json();
      setIsEditMode(true);
      setVulnerability(data.vulnerabilityName);
      setSeverity(data.severity);
      setDescription(data.description);
      setParameter(data.affectedParameter);
      setrecommend(data.recommendation);
      setOWASP(data.OWASP);
      setScore(data.cvssScore);
      setCveId(data.cveId);
      setString(data.cvssString);
      setExpolitation(data.exploitation);
      setFactor(data.factor);
      setRisk(data.risk)

      // Basic PoC descriptions
      const initialPoc = data.poc.map(item => ({
        poc: item.poc,
        filePath: item.filePath,
        pocImageURL: null
      }));

      setPocDescription(initialPoc);

      fetchPOCImages(id, initialPoc);

    } catch (error) {
      console.error("Error fetching vulnerability:", error);
    }
  };

  const handleUpdateVulnerability = async () => {
    try {
      if (capitalizedClientName === '') {
        return setVulnerabilityError('Vulnerability name required!');
      }
      if (severity === '' || severity === 'Select') {
        return setSeverityError('Severity not selected!');
      }
      if (description === '') {
        return setDescriptionError('Description required!');
      }
      if (parameter === '') {
        return setParameterError('Affected parameter not specified!');
      }
      if (recommend === '') {
        return setrecommendationsError('Recommendations required!');
      }

      if (cveId === '') {
        return setCveIdError('CVE Id required!');
      }
      if (risk === '') {
        return setCveIdError('Risk required!');
      }

      const formData = new FormData();

      // Core vulnerability fields
      formData.append('projectId', projectid);
      formData.append('vulnerabilityName', capitalizeFirstLetter(vulnerability));
      formData.append('severity', severity);
      formData.append('description', description);
      formData.append('affectedParameter', parameter);
      formData.append('recommendation', recommend);
      formData.append('OWASP', OWASP);
      formData.append('cvssScore', score);
      formData.append('cvssString', string);
      formData.append('exploitation', exploitation);
      formData.append('factor', factor);
      formData.append('cveId', cveId);
      formData.append('vulnId', vulId);
      formData.append('risk', risk)

      // Append PoC content, file paths, and files
      pocDescription.forEach((poc, index) => {
        formData.append(`poc[${index}][poc]`, poc.poc || '');

        // Always send the file path (if it exists)
        if (poc.filePath) {
          formData.append(`poc[${index}][filePath]`, poc.filePath);
        }

        // Append any newly uploaded files
        if (Array.isArray(poc.files)) {
          poc.files.forEach((file, fileIndex) => {
            if (file instanceof File) {
              formData.append(`poc[${index}][file]`, file);
            } else {
              console.warn(`Skipping invalid file at poc[${index}]:`, file);
            }
          });
        }
      });

      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
        } else {
        }
      }

      // Send request
      const response = await fetch(`${url}/updatevulnerability`, {
        method: 'PUT',
        credentials: 'include',
        body: formData
      });

      if (response.ok) {
        toast.success("Vulnerability updated successfully...", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        navigate(-1)
        setVulnerability('');
        setSeverity('Select');
        setDescription('');
        setParameter('');
        setrecommend('');
        setOWASP('');
        setFiles(null);
        setFactor('')
        setScore('');
        setCveId('');
        setString('');
        setExpolitation('');
        setPocDescription([{ poc: '', files: [], pocImageURL: '' }]);
        document.getElementById('fileInput').value = '';

      } else if (response.status === 403) {
        toast.error('File size too large', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      } else if (response.status === 440) {
        logout();
        toast.error('User logout due to inactivity', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      } else {
        const resText = await response.text();
        console.error('Update failed:', resText);
        toast.error('Update failed');
      }

    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.message;
      console.error('Runtime error:', errorMessage);
      toast.error('Unexpected Error');
    }
  }


  useEffect(() => {
    if (!emailVer.endsWith('@isecurion.com')) {
      logout()
      return;
    }
    fetchProjectName()
    if (vulId) {
      fetchVulnerabilityDetails(vulId);
    }
    window.scrollTo(0, 0);
  }, [vulId])

  const handleInput = (event) => {
    const bullet = "\u2022";
    const newLength = event.target.value.length;
    const characterCode = event.target.value.substr(-1).charCodeAt(0);
    if (newLength > previousLength) {
      if (characterCode === 10) {
        event.target.value = `${event.target.value}${bullet} `;
      } else if (newLength === 1) {
        event.target.value = ` ${event.target.value}`;
      }
    }
    previousLength = newLength;
  }

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const capitalizedClientName = capitalizeFirstLetter(vulnerability);

  const allowedFileTypes = ['image/jpg', 'image/png', 'image/jpeg', 'image/jfif'];


  //Refer file.js file for backend code
  const handleUpload = async () => {
    try {
      if (capitalizedClientName === '') {
        return setVulnerabilityError('Vulnerability name required!');
      }
      if (severity === '' || severity === 'Select') {
        return setSeverityError('Severity not selected!');
      }
      if (description === '') {
        return setDescriptionError('Description required!');
      }
      if (parameter === '') {
        return setParameterError('Affected parameter not specified!');
      }
      if (risk === '') {
        return setRiskError('Risk not specified!');
      }
      if (recommend === '') {
        return setrecommendationsError('Recommendations required!');
      }

      if (
        (applicationType !== "Secure Code Review" &&
          applicationType !== "Configuration Review" &&
          applicationType !== "VA Scan" &&
          applicationType !== "External Network Penetration Testing" &&
          applicationType !== "Internal Network Penetration Testing") &&
        OWASP === ''
      ) {
        return setOWASPError('OWASP Top 10 required!');
      }
      // if (factor === '') {
      //   return setFactorError('Attribute factor required!');
      // }
      if (cveId === '') {
        return setCveIdError('CVE Id required!');
      }
      // if (score === '') {
      //   return setScoreError('Score required!');
      // }
      // if (string === '') {
      //   return setStringError('String required!');
      // }
      // if (exploitation === '') {
      //   return setExploitationError('Ease of exploitation required!');
      // }
      setLoading(true)
      const formData = new FormData();

      // Core vulnerability fields
      formData.append('projectId', projectid);
      formData.append('vulnerabilityName', capitalizeFirstLetter(vulnerability));
      formData.append('severity', severity);
      formData.append('description', description);
      formData.append('affectedParameter', parameter);
      formData.append('recommendation', recommend);
      formData.append('OWASP', OWASP);
      formData.append('cvssScore', score);
      formData.append('cvssString', string);
      formData.append('exploitation', exploitation);
      formData.append('factor', factor);
      formData.append('cveId', cveId);
      formData.append('risk', risk)

      pocDescription.forEach((poc, index) => {
        formData.append(`poc[${index}][poc]`, poc.poc || '');

        if (Array.isArray(poc.files)) {
          poc.files.forEach((file, fileIndex) => {
            if (file instanceof File) {
              formData.append(`poc[${index}][file]`, file);
            } else {
              console.warn(`Skipping invalid file at poc[${index}]:`, file);
            }
          });
        }
      });

      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {

        } else {
        }
      }

      // Send request
      const response = await fetch(`${url}/uploadvulnerability`, {
        method: 'POST',
        credentials: 'include',
        body: formData
      });

      if (response.ok) {
        addVulnerabilitySuccess();
        setLoading(false)
        // Reset form state
        setVulnerability('');
        setSeverity('Select');
        setDescription('');
        setParameter('');
        setrecommend('');
        setOWASP('');
        setFiles(null);
        setFactor('')
        setScore('');
        setCveId('');
        setString('');
        setExpolitation('');
        setRisk('')
        setPocDescription([{ poc: '', files: [], pocImageURL: '' }]);
        document.getElementById('fileInput').value = '';
      } else if (response.status === 403) {
        setIsEditMode(false)
        toast.error('File size too large', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      } else if (response.status === 440) {
        logout();
        setLoading(false)
        toast.error('User logout due to inactivity', {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      } else {
        const resText = await response.text();
        console.error('Upload failed:', resText);
        toast.error('Upload failed');
        setLoading(false)
      }

    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.message;
      console.error('Runtime error:', errorMessage);
      toast.error('Unexpected Error');
      setLoading(false)
    }
  };


  return (
    <div className="isecurion-user-table">
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='isecurion_navbar_second'><IsecNavbar2 projectName={projectName} projectid={projectid} /></div>
      </div>

      <div className='wrap_isecurion_navbar_usertable'>
        <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
          <IsecNavbar />
        </div>
        <div className={isSidebarCollapsed ? 'wrap_isecurion_dashboard_data_open' : 'wrap_isecurion_dashboard_data'} >
          <div className='wrap_pagedata'>
            <div className='wrap_first_second_inputs'>
              <div className='wrap_first_inputs'>
                <div className='first_vulnerability'>
                  <label>Vulnerability</label>
                  <textarea
                    placeholder='Vulnerability name'
                    value={vulnerability}
                    style={{ padding: "8px" }}
                    onChange={(e) => {
                      setVulnerability(capitalizeFirstLetter(e.target.value))
                      setVulnerabilityError('')
                    }} />
                  {vulnerabilityError && <p className='vulnererrorh5'>{vulnerabilityError}</p>}
                </div>

                <div className='second-description'>
                  <label>Description </label>
                  <textarea
                    placeholder='Vulnerability description'
                    style={{ padding: "8px" }}
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value)
                      setDescriptionError('')
                    }} />
                  {descriptionError && <p>{descriptionError}</p>}
                </div>

                <div className='fourth-recommend'>
                  <label>Recommendations</label>
                  <textarea
                    placeholder='Recommendations'
                    style={{ padding: "8px" }}
                    value={recommend}
                    onInput={handleInput}
                    rows="10"
                    onChange={(e) => {
                      setrecommend(e.target.value)
                      setrecommendationsError('')
                    }} />
                  {recommendationsError && <p>{recommendationsError}</p>}
                </div>

                <div className='owasp_category'>
                  <label>Ease of exploitation</label>
                  <select value={exploitation} onChange={(e) => {
                    setExpolitation(e.target.value)
                    setExploitationError('')
                  }}>
                    <option value="">Select</option>
                    <option value="Easy">Easy</option>
                    <option value="Moderate">Moderate</option>
                    <option value="Difficult">Difficult</option>

                  </select>
                  {exploitationError && <p>{exploitationError}</p>}
                </div>

                <div className='fourth-recommend'>
                  <label>CVE Id</label>
                  <input
                    placeholder='CVE Id'
                    value={cveId}
                    onChange={(e) => {
                      setCveId(e.target.value)
                      setCveIdError('')
                    }} />
                  {cveIdError && <p>{cveIdError}</p>}
                </div>


              </div>

              <div className='wrap_second_inputs'>
                <div className='second-severity'>
                  <label>Severity</label>
                  <select data-testid="Select" value={severity} onChange={(e) => {
                    setSeverity(e.target.value)
                    setSeverityError('')
                  }}>
                    <option>Select</option>
                    <option>Critical</option>
                    <option>High</option>
                    <option>Medium</option>
                    <option>Low</option>
                    <option>Info</option>
                  </select>
                  {severityError && <p className='severity_errorh5'>{severityError}</p>}
                </div>

                <div className='third-parameter'>
                  <label>Affected parameter </label>
                  <textarea
                    placeholder='Affected item'
                    style={{ padding: "8px" }}
                    value={parameter}
                    onChange={(e) => {
                      setParameter(e.target.value)
                      setParameterError('')
                    }} />
                  {parameterError && <p>{parameterError}</p>}
                </div>

                <div className='third-risk_parameter' >
                  <label>Risk/Impact </label>
                  <textarea
                    placeholder='Risk'
                    style={{ padding: "8px" }}
                    value={risk}
                    onChange={(e) => {
                      setRisk(e.target.value)
                      setRiskError('')
                    }} />
                  {riskError && <p>{riskError}</p>}
                </div>

                {applicationType === "WEB" ? (
                  <div className='owasp_category'>
                    <label>OWASP top 10 category (2025)</label>
                    <select value={OWASP} onChange={(e) => {
                      setOWASP(e.target.value)
                      setOWASPError('')
                    }}>
                      <option value="">Select</option>
                      <option value="Broken Access Control - [A1]">Broken Access Control</option>
                      <option value="Security Misconfiguration - [A2]">Security Misconfiguration</option>
                      <option value="Software Supply Chain Failures - [A3]">Software Supply Chain Failures</option>
                      <option value="Cryptographic Failures - [A4]">Cryptographic Failures</option>
                      <option value="Injection - [A5]">Injection</option>
                      <option value="Insecure Design - [A6]">Insecure Design</option>
                      <option value="Authentication Failures - [A7]">Authentication Failures</option>
                      <option value="Software or Data Integrity Failures - [A8]">Software or Data Integrity Failures</option>
                      <option value="Security Logging and Alerting Failures - [A9]">Security Logging and Alerting Failures</option>
                      <option value="Mishandling of Exceptional Conditions - [A10]">Mishandling of Exceptional Conditions</option>
                    </select>
                    {OWASPError && <p>{OWASPError}</p>}
                  </div>
                ) : ''}

                {applicationType === "API" ? (
                  <div className='owasp_category'>
                    <label>OWASP top 10 category (2023)</label>
                    <select value={OWASP} onChange={(e) => {
                      setOWASP(e.target.value)
                      setOWASPError('')
                    }}>
                      <option value="">Select</option>
                      <option value="Unsafe Consumption of APIs">Unsafe Consumption of APIs</option>
                      <option value="Improper Inventory Management">Improper Inventory Management</option>
                      <option value="Security Misconfiguration">Security Misconfiguration</option>
                      <option value="Server Side Request Forgery">Server Side Request Forgery</option>
                      <option value="Unrestricted Access to sensitive Business Flows">Unrestricted Access to sensitive Business Flows</option>
                      <option value="Broken Function Level Authorization">Broken Function Level Authorization</option>
                      <option value="Unrestricted Resource Consumption">Unrestricted Resource Consumption</option>
                      <option value="Broken Object Property Level Authorization">Broken Object Property Level Authorization</option>
                      <option value="Broken Authentication">Broken Authentication</option>
                      <option value="Broken Object Level Authorization">Broken Object Level Authorization</option>
                    </select>
                    {OWASPError && <p>{OWASPError}</p>}
                  </div>
                ) : ''}

                {applicationType === "Desktop App" ? (
                  <div className='owasp_category'>
                    <label>OWASP top 10 category (2021)</label>
                    <select value={OWASP} onChange={(e) => {
                      setOWASP(e.target.value)
                      setOWASPError('')
                    }}>
                      <option value="">Select</option>
                      <option value="Injections">Injections</option>
                      <option value="Broken Authentication & Session Management">Broken Authentication & Session Management</option>
                      <option value="Sensitive Data Exposure">Sensitive Data Exposure</option>
                      <option value="Improper Cryptography Usage">Improper Cryptography Usage</option>
                      <option value="Improper Authorization">Improper Authorization</option>
                      <option value="Security Misconfiguration">Security Misconfiguration</option>
                      <option value="Insecure Communication">Insecure Communication</option>
                      <option value="Poor Code Quality">Poor Code Quality</option>
                      <option value="Using Components with Known Vulnerabilities">Using Components with Known Vulnerabilities</option>
                      <option value="Insufficient Logging & Monitoring">Insufficient Logging & Monitoring</option>
                    </select>
                    {OWASPError && <p>{OWASPError}</p>}
                  </div>
                ) : ''}

                {applicationType === "ANDROID" || applicationType === "IOS" || applicationType === 'ANDROID & IOS' ? (
                  <div className='owasp_category'>
                    <label>OWASP top 10 category (2021)</label>
                    <select value={OWASP} onChange={(e) => {
                      setOWASP(e.target.value)
                      setOWASPError('')
                    }}>
                      <option value="">Select</option>
                      <option value="Improper Credential Usage">Improper Credential Usage</option>
                      <option value="Inadequate Supply Chain Security">Inadequate Supply Chain Security</option>
                      <option value="Insecure Authentication/Authorization">Insecure Authentication/Authorization</option>
                      <option value="Insufficient Input/Output Validation">Insufficient Input/Output Validation</option>
                      <option value="Insecure Communication">Insecure Communication</option>
                      <option value="Inadequate Privacy Controls">Inadequate Privacy Controls</option>
                      <option value="Insufficient Binary Protections">Insufficient Binary Protections</option>
                      <option value="Security Misconfiguration">Security Misconfiguration</option>
                      <option value="Insecure Data Storage">Insecure Data Storage</option>
                      <option value="Insufficient Cryptography">Insufficient Cryptography</option>
                    </select>
                    {OWASPError && <p>{OWASPError}</p>}
                  </div>
                ) : ''}

                <div className='owasp_category'>
                  <label>Attribute Factor</label>
                  <select value={factor} onChange={(e) => {
                    setFactor(e.target.value)
                    setFactorError('')
                  }}>
                    <option value="">Select</option>
                    <option value="Coding Error">Coding Error</option>
                    <option value="Network Error">Network Error</option>
                    <option value="Database Error">Database Error</option>
                    <option value="Configuration Error">Configuration Error</option>
                    <option value="Vulnerable Libraries">Vulnerable Libraries</option>
                    <option value="Deployment Error">Deployment Error</option>
                    <option value="Design Error">Design Error</option>
                    <option value="Authentication Error">Authentication Error</option>
                    <option value="Access Control Error">Access Control Error</option>

                  </select>
                  {factorError && <p>{factorError}</p>}
                </div>

                <div className='fourth-recommend'>
                  <label>CVSS score</label>
                  <input
                    placeholder='CVSS score'
                    value={score}
                    onChange={(e) => {
                      setScore(e.target.value)
                      setScoreError('')
                    }} />
                  {scoreError && <p>{scoreError}</p>}
                </div>

                <div className='fourth-recommend'>
                  <label>CVSS string</label>
                  <input
                    placeholder='CVSS string'
                    value={string}
                    onChange={(e) => {
                      setString(e.target.value)
                      setStringError('')
                    }} />
                  {stringError && <p>{stringError}</p>}
                </div>
              </div>
            </div>

            <hr style={{ width: '100%', border: '0.5px solid black' }} />

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {pocDescription.map((item, index) => (
                <div key={index} className='wrap_poc_description'  >
                  {/* PoC Input Area */}
                  <div className='wrap_first_inputs' style={{ flex: 1 }}>
                    <div className='second-description_vul'>
                      <label>POC Description</label>
                      <textarea
                        placeholder='Enter description...'
                        style={{ padding: '8px', width: '100%', height: '50px' }}
                        value={item.poc}
                        onChange={(e) => {
                          const updated = [...pocDescription];
                          updated[index].poc = e.target.value;
                          setPocDescription(updated);
                        }}
                      />
                    </div>
                  </div>

                  {/* File Upload Area */}
                  <div className='wrap_second_inputs' style={{ flex: 1 }}>
                    <div className='last_image' style={{ marginTop: '10px' }}>
                      <label>POC Files</label>
                      <p style={{ fontSize: "11.5px", fontStyle: "italic", textAlign: "justify", marginTop: "5px", marginLeft: "0px", marginBottom: '5px' }}>To include multiple Proof of Concept (POC) for the same description, click the "Add POC" button below. There's no need to provide a description; just upload your image.</p>
                      <input
                        type='file'
                        id='fileInput'
                        accept='image/*'
                        onChange={(e) => {
                          const file = e.target.files[0];
                          const updated = [...pocDescription];

                          if (file) {
                            updated[index].files = [file];
                            updated[index].pocImageURL = URL.createObjectURL(file);
                          }
                          setPocDescription(updated);
                        }}
                      />

                      {/* Image Preview */}
                      {item.pocImageURL && (
                        <div style={{ marginTop: '10px' }}>
                          <img
                            src={item.pocImageURL}
                            alt='Uploaded PoC'
                            style={{ width: '200px', height: '100px', objectFit: 'cover', borderRadius: '4px' }}
                          />
                        </div>
                      )}
                    </div>


                    {pocDescription.length > 1 && (
                      <button
                        style={{
                          marginTop: '10px',
                          backgroundColor: '#e74c3c',
                          color: 'white',
                          border: 'none',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          const updated = pocDescription.filter((_, i) => i !== index);
                          setPocDescription(updated);
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} style={{ marginRight: '5px' }} />
                        Delete POC
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <button
                  className='add_more_button'
                  style={{
                    width: '120px',
                    backgroundColor: '#e76a34',
                    color: '#fff',
                    border: 'none',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setPocDescription([
                      ...pocDescription,
                      {
                        poc: '',
                        files: [],
                        pocImageURL: '',
                      },
                    ]);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
                  Add POC
                </button>
              </div>

            </div>

          </div>

          <div className='wrap_vul_button'>
            <button
              onClick={isEditMode ? handleUpdateVulnerability : handleUpload}
              className='upload_butt'
            >
              {loading
                ? <span>{isEditMode ? 'Updating...' : 'Uploading...'}</span>
                : isEditMode ? 'Update Vulnerability' : 'Upload Vulnerability'}
            </button>
          </div>


        </div>

        {waitingPage && (
          <div className='waiting_page'>
            <div className='wrap_Waiting'>
              <p>Please wait...</p>
              <div id='loaderPage' className='loading-spinnerPage'></div>
            </div>
          </div>
        )}

      </div>
    </div>



  );
};

export default AddVulnerability;
